import React from "react";

const HeadingCard = ({ title, rightContent, children }) => {
  return (
    <div className="bg-white border border-[#F1F2F9] shadow-[0px_1px_8px_rgba(25,33,61,0.06)] rounded-[12px]">
      {/* Header */}
      <div
  className={`bg-[#FF8E1C] text-white px-[10px] py-[20px] md:px-[18px] md:py-[32px] rounded-t-[12px] 
          ${rightContent ? "flex justify-between items-center" : "text-center"}`}
      >
        <h2
          className={`font-lato not-italic font-bold text-[24px] leading-[115%] text-white
            ${rightContent ? "" : "w-full text-center"}`}
        >
          {title}
        </h2>

        {rightContent && <span className="text-sm">{rightContent}</span>}
      </div>

      {/* Body */}
      <div className="bg-white p-[18px] md:p-[24px]  rounded-b-[12px]">{children}</div>
    </div>
  );
};

export default HeadingCard;
